import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { usePostPaymentDetailsMutation } from '../../services/accountPayableApi';
export function usePostPaymentDetails() {
    const { t } = useTranslation();
    const [trigger] = usePostPaymentDetailsMutation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [paymentDetails, setPaymentDetails] = useState();
    async function postPaymentDetails(body) {
        setLoading(true);
        setError(undefined);
        setPaymentDetails(undefined);
        try {
            const { data } = await trigger(body);
            if (!data?.result) {
                setError(t('can-not-update-bank-details'));
            }
            else {
                setPaymentDetails(data.result);
            }
        }
        catch {
            setError(t('can-not-update-bank-details'));
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        paymentDetails,
        setPaymentDetails,
        postPaymentDetails,
    };
}
